import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {XW2GameMode, XwaysHoarder2} from "../../../XwaysHoarder2";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XwaysHoarder2Model} from "../../../server/XwaysHoarder2Model";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";


export class MaxWinPresentation implements SimplePresentation {

    name: string = "MaxWinPresentation";

    constructor() {
    }

    shouldRun(): boolean {
        return XwaysHoarder2.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        XwaysHoarder2.keypadPlugin.setZeroBetSpinCounter(-1);
        controller.setSkipCallback();
        XwaysHoarder2.reelView.symbolsToNormalLayer();

        const fromFs = XwaysHoarder2Model.isCurrentModeAndEnteringNormal(XwaysHoarder2.model.data, GameMode.FREESPIN);
        const fromSfS = XwaysHoarder2Model.isCurrentModeAndEnteringNormal(XwaysHoarder2.model.data, XW2GameMode.SUPER_FREESPIN);

        if (!XwaysHoarder2.model.isBigWin) {
            tl.add(XwaysHoarder2.winView.showWinCap());
            tl.add(XwaysHoarder2.winView.getWinCountUp(0, XwaysHoarder2.model.gameData.accumulatedRoundWin, 7, 0, new PIXI.Point(360, 570), 1, false), "<");

            tl.add(() => {
                controller.setSkipCallback(() => { tl.seek("MAX_WIN_END", false); })
            }, '<2');
            tl.addLabel("MAX_WIN_END", '<10');
            tl.add(() => { controller.setSkipCallback() }, '<10');

            tl.to(this,{duration:1.5});
            tl.add(() => {
                XwaysHoarder2.winView.getWinCountUpFade(XwaysHoarder2.model.gameData.totalSpinWinnings, 0.5);
            });
            tl.add(XwaysHoarder2.winView.showWinCapTimes());
        }
        if (fromFs || fromSfS) {
    
            tl.add([
                XwaysHoarder2.backgroundElements.setBackground(GameMode.NORMAL, XwaysHoarder2.model.data.mode),
                XwaysHoarder2.foregroundElements.setForeground(GameMode.NORMAL, XwaysHoarder2.model.data.mode)
            ]);
            tl.add(() => {
                XwaysHoarder2.fsIndicators.resetAllIndicators();
                XwaysHoarder2.fsIndicators.hide();
            //    XwaysHoarder2.reelView.resetLockedXways();
            }, "<");
        }
        tl.add(() => {
            XwaysHoarder2.keypadPlugin.setWin(XwaysHoarder2.model.data.accumulatedRoundWin, true, XwaysHoarder2.isWinBelowStake());
        });
        tl.add(XwaysHoarder2.transitionScreen.enableButton(() => this.complete(controller)),"<");

    }

    private complete(controller: SimplePresentationRunnerController): void {
        const endWinCapTL: gsap.core.Timeline = gsap.timeline();
        endWinCapTL.add(XwaysHoarder2.winView.hideWinCap());
        endWinCapTL.add(() => {
            XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.MAIN_GAME_MUSIC});
            controller.setSkipCallback();
            controller.finish();
        });
    }

}